export default "__VITE_ASSET__b6ab66b1__"